/* eslint-disable */

function PipelineChart(el) {
  const pipelineTable = document.querySelector('.pipeline-table');
  const chartRows = document.querySelectorAll('.chart-row');
  const chartRowsArr = Array.prototype.slice.call(chartRows);

  function calculateRowSize(){
    chartRowsArr.forEach(function(row, index){
      const columnCount = parseInt(row.dataset.programPhases);
      const progress = parseInt(row.dataset.programProgress);
      const track  = row.querySelector('.pipeline-chart-bar');
      if(track){
        const trackWidth = track.offsetWidth;
        const allTracks = trackWidth * columnCount;
        track.style.width = allTracks * (progress/100) + "px";
      }
    });
  }

  calculateRowSize();

  const resizeObserver = new ResizeObserver(function(entries){
    for(const entry of entries){
      calculateRowSize();
      console.log('hello?')
    }
  });

  resizeObserver.observe(document.body);

  // Mobile Logic
  const stickyHeaders = document.querySelectorAll('.chart-heading__sticky');

  const io_options = {
    rootMargin: '0px 0px -98% 0px',
  };

  function io_callback (entries, observer) {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        entry.target.classList.add('sticky');
        entry.target.classList.add('top-0');
      } else {
        entry.target.classList.remove('sticky');
        entry.target.classList.remove('top-0');
      }
    });
  }

  const io_observer = new IntersectionObserver(io_callback, io_options);

  if(stickyHeaders){
    const stickyHeadersArr = Array.from(stickyHeaders);

    stickyHeadersArr.forEach(element => {
      io_observer.observe(element);
    });
  }
}

export default PipelineChart;
